import { CustomizedTypography, VStack } from '@components/Customized';

const ProgressInfoQA = () => {
  return (
    <VStack gap={16}>
      <div>
        <CustomizedTypography variant="subtitle2" fontWeight="500">
          계산서가 필요하다면?
        </CustomizedTypography>
        <CustomizedTypography variant="subtitle2" color="textSecondary">
          제조의 주체는 파트너이므로 계산서가 필요한 경우 구매확정 시 파트너에게
          요청해주세요.
        </CustomizedTypography>
      </div>
      <div>
        <CustomizedTypography variant="subtitle2" fontWeight="500">
          분쟁조정 신청이 필요하다면?
        </CustomizedTypography>
        <CustomizedTypography variant="subtitle2" color="textSecondary">
          분쟁 조정 요청 시 캐파 담당자가 고객과 파트너님의 발주서를 바탕으로
          중재를 진행하여 지급 결정을 내리게 됩니다. 캐파 하단에 위치한 채널톡을
          이용해 주세요.
        </CustomizedTypography>
      </div>
    </VStack>
  );
};

export default ProgressInfoQA;
